import { render, staticRenderFns } from "./SearchAndFilter.vue?vue&type=template&id=0aa0ede1&scoped=true&"
import script from "./SearchAndFilter.vue?vue&type=script&lang=ts&"
export * from "./SearchAndFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SearchAndFilter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchAndFilter.vue?vue&type=style&index=1&id=0aa0ede1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0ede1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa0ede1')) {
      api.createRecord('0aa0ede1', component.options)
    } else {
      api.reload('0aa0ede1', component.options)
    }
    module.hot.accept("./SearchAndFilter.vue?vue&type=template&id=0aa0ede1&scoped=true&", function () {
      api.rerender('0aa0ede1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/SearchAndFilter.vue"
export default component.exports